/** Controller for hiding content during a turbo-frame form submission
 *  and optionally revealing another element.
 *  Uses the "hidden" CSS utility class.
 *
 *  Example usage:
 *  ```html
 *  <form id="idIsRequired"
 *        data-turbo-frame-suspense-target="turboForm"
 *        data-turbo-frame="whatever-frame-id">...
 *    <!-- Response should include a turbo-frame with the  -->
 *  </form>
 *  <div data-turbo-frame-suspense-target="showInSuspense" class="hidden ...">
 *    loading...
 *  </div>
 *  <data-frame id="whatever-frame-id" data-turbo-frame-suspense-target="hideInSuspense">
 *    content goes here
 *  </data-frame>
 *  ```
 */

import { Controller } from '@hotwired/stimulus';
import { createFrameListener } from 'banzai/manager/front/util/turbo.js';

function resultsLoading(hide, show) {
  hide?.classList?.add('hidden');
  show?.classList?.remove('hidden');
}

export default class extends Controller {
  static targets = [
    'showInSuspense', // an element to show while user is in suspense
    'hideInSuspense', // a <data-frame> being replaced by form response (id is required)
    'turboForm',
  ]; // a <form> (must be turbo-enabled)

  connect() {
    createFrameListener('turbo:submit-start', this.turboFormTarget.id, () =>
      resultsLoading(this.hideInSuspenseTarget, this.showInSuspenseTarget),
    );
    createFrameListener('turbo:frame-render', this.hideInSuspenseTarget.id, () =>
      resultsLoading(this.showInSuspenseTarget, this.hideInSuspenseTarget),
    );
  }
}
